document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.menu-toggle');
  const menu = document.getElementById('MobileMenu');
  if (btn && menu) btn.addEventListener('click', () => { const open = btn.getAttribute('aria-expanded') === 'true'; btn.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('open', !open); });

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const index = thumb.dataset.galleryThumb;
      slides.forEach(s => s.classList.toggle('is-active', s.dataset.gallerySlide === index));
      thumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
    }));
  });

  // AliExpress/import apps sometimes create size variants in a random order.
  // Sort only options whose name contains "size", using the first number in each value.
  document.querySelectorAll('.pe-option-group').forEach(group => {
    const legend = group.querySelector('legend');
    const buttons = group.querySelector('.pe-option-buttons');
    if (!legend || !buttons || !/size/i.test(legend.textContent)) return;

    const labels = [...buttons.querySelectorAll(':scope > label')];
    const numericValue = label => {
      const value = label.querySelector('input')?.value || label.textContent || '';
      const match = value.replace(',', '.').match(/\d+(?:\.\d+)?/);
      return match ? Number.parseFloat(match[0]) : Number.POSITIVE_INFINITY;
    };

    labels
      .map((label, originalIndex) => ({ label, originalIndex, value: numericValue(label) }))
      .sort((a, b) => (a.value - b.value) || (a.originalIndex - b.originalIndex))
      .forEach(item => buttons.appendChild(item.label));
  });

  const variantDataEl = document.querySelector('[data-product-variants]');
  if (variantDataEl) {
    const variants = JSON.parse(variantDataEl.textContent);
    const optionGroups = [...document.querySelectorAll('.pe-option-group')];
    const idInput = document.querySelector('[data-variant-id]');
    const current = document.querySelector('[data-current-price]');
    const compare = document.querySelector('[data-compare-price]');
    const badge = document.querySelector('[data-sale-badge]');
    const add = document.querySelector('[data-add-to-cart]');
    const updateVariant = () => {
      const selected = optionGroups.map(group => group.querySelector('input:checked')?.value);
      const variant = variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (!variant) return;
      idInput.value = variant.id;
      current.textContent = variant.price_formatted;
      if (variant.compare_at_price > variant.price) { compare.textContent = variant.compare_at_formatted; compare.classList.remove('is-hidden'); badge.textContent = `Save ${variant.savings_formatted}`; badge.classList.remove('is-hidden'); }
      else { compare.textContent = ''; compare.classList.add('is-hidden'); badge.textContent = ''; badge.classList.add('is-hidden'); }
      add.disabled = !variant.available; add.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';

      if (variant.featured_media_id !== null) {
        const gallery = document.querySelector('[data-product-gallery]');
        if (gallery) {
          const slides = gallery.querySelectorAll('[data-gallery-slide]');
          const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
          const mediaId = String(variant.featured_media_id);
          slides.forEach(s => s.classList.toggle('is-active', s.dataset.mediaId === mediaId));
          thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.mediaId === mediaId));
        }
      }
    };
    optionGroups.forEach(g => g.addEventListener('change', updateVariant));
  }

});
